import React, { createContext, useState, useEffect, useContext } from 'react';
import { fetchUserProfile } from '../services/userService';
import axios from 'axios';
import { jwtDecode } from 'jwt-decode';
import { useSelector } from 'react-redux';
import { logoutUser } from '../services/authService';
import { setAxiosLoggingOut } from '../api/authState';

// Create the AuthContext
const AuthContext = createContext();

// Custom hook to use the AuthContext
export const useAuth = () => useContext(AuthContext);

export const AuthProvider = ({ children }) => {
  const [isLoggingOut, setIsLoggingOut] = useState(false);
  const [accessToken, setAccessToken] = useState(localStorage.getItem('access'));
  const [role, setRole] = useState(localStorage.getItem('role'));
  const [isTokenExpired, setIsTokenExpired] = useState(false);
  const [userId, setUserId] = useState(null);
  const profile = useSelector((state) => state.profile.data);
  const profileId = profile?.profile_id || null;
  const [displayName, setDisplayName] = useState(localStorage.getItem('first_name'));
  const [profileThumbnail, setProfileThumbnail] = useState(localStorage.getItem('avatar'));


  // Redirect control
  const [isRedirecting, setIsRedirecting] = useState(false);


  useEffect(() => {
    if (accessToken) {
      try {
        const decodedToken = jwtDecode(accessToken);
        setUserId(decodedToken.user_id);
        if (decodedToken.role) {
          setRole(decodedToken.role);
          localStorage.setItem('role', decodedToken.role);
        }
      } catch (err) {
        console.error('Error decoding token:', err);
      }
    }
  }, [accessToken]);

  // Logout function
  const logout = async () => {
    setIsLoggingOut(true);
    setAxiosLoggingOut(true);

    try {
      await logoutUser(); // ✅ deletes refresh cookie
    } catch (e) {
      // ignore — logout must still continue
    } finally {
      // 1. Fully reset all Auth Context states
      setAccessToken(null);
      setIsTokenExpired(false);
      setUserId(null);
      setRole(null);
      setDisplayName(null);        // ✅ Added to prevent stale UI
      setProfileThumbnail(null);   // ✅ Added to prevent stale UI

      // 2. Safe LocalStorage cleanup (Preserving your theme!)
      Object.keys(localStorage).forEach((key) => {
        if (key !== 'isDarkMode') {
          localStorage.removeItem(key);
        }
      });

      setIsLoggingOut(false);
    }
  };

  // Provide context value
  const value = {
    isLoggingOut,
    setIsLoggingOut,
    accessToken,
    setAccessToken,
    setIsTokenExpired,
    isTokenExpired,
    userId,
    setUserId,
    role,
    setRole,
    profileId,
    isRedirecting,
    setIsRedirecting,
    displayName,
    setDisplayName,
    profileThumbnail,
    setProfileThumbnail,
    logout,// Pass Axios instance so other components can use it
  };

  return <AuthContext.Provider value={value}>{children}</AuthContext.Provider>;
};

export default AuthContext;